import React, { useEffect, useState } from 'react';

import { useNavigate, useLocation, Link } from 'react-router-dom';
import moment from 'moment';

import { motion, useMotionValueEvent, useScroll } from "framer-motion";

import routes from "../libs/routes";
import images from "../libs/images";
import consts from "../libs/consts";

import { useWindowSize } from '../utils/utils';
import { useUser, useMenu, usePopup, useHeader } from "../zustand/store.js";
import { LangText } from "../zustand/dict.js";

import LeftNav from '../components/LeftNav';
import Language from '../components/Language';
import Credits from '../components/Credits';
import Profile from '../components/Profile';
import Sign from '../components/Sign';

const parentVariants = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: "-4rem" },
};


export default function Header() {

    const { width, height } = useWindowSize();
    const { pathname } = useLocation();

    const { token, user } = useUser();
    const { mode, onBackClick } = useHeader();
    const { menu } = useMenu();

    const { menuPop, signPop, openSignPop, openMenu, closeMenu } = usePopup();

    const { scrollY } = useScroll();
    const [hidden, setHidden] = useState(false);
    const [prevScroll, setPrevScroll] = useState(0);
    const [headerBtnClass, setHeaderBtnClass] = useState("menu_btn")

    useEffect(() => {
        console.log(mode)
        if (mode == consts.headerMode.BACKONLY) {
            setHeaderBtnClass("menu_back_btn")
            setHidden(false);
        } else if (mode == consts.headerMode.BACK) {
            setHeaderBtnClass("menu_back_btn")
            setHidden(false);
        } else {
            setHeaderBtnClass("menu_btn")
        }
    }, [mode])

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    useMotionValueEvent(scrollY, "change", (latest) => {
        update(latest, prevScroll);
        setPrevScroll(latest);
    });


    useEffect(() => {
        // console.log('menuPop', menuPop);

        if (signPop) {
            document.body.style.overflow = 'hidden';
            return;
        }

        if (width <= consts.mobileWidth && menuPop) {
            document.body.style.overflow = 'hidden';
            return;
        }

        document.body.style.overflow = '';
        // if(show) {
        //     animateCSS({
        //         element: '.left_nav', 
        //         animation: 'bounceInLeft',
        //         show: 'flex'
        //     });
        // }

    }, [menuPop, signPop, width]);

    const menuFunc = () => {
        menuPop ? closeMenu() : openMenu();
    }

    const backFunc = () => {
        console.log("header back click!")
    }

    const update = (latest, prev) => {
        if (latest < prev) {
            setHidden(false);
            // console.log("visible");
        } else if (latest > 100 && latest > prev && !menuPop && mode == consts.headerMode.NORMAL) {
            setHidden(true);
            // console.log("hidden");
        }
    }

    return (
        <>
            <motion.nav
                className={`header`}
                variants={parentVariants}
                animate={(hidden && width <= consts.mobileWidth) ? "hidden" : "visible"}
                transition={{ type: "keyframes" }}
            >

                <div className='header_left'>
                    <button
                        className={`${headerBtnClass} ${consts.animationFadeIn}`}
                        onClick={onBackClick ? onBackClick : menuFunc} />
                    {(mode == consts.headerMode.NORMAL || mode == consts.headerMode.BACK) && <Link
                        className={`logo ${consts.animationFadeIn}`}
                        // to={routes.main}
                        onClick={() => { window.location.href = "/" }} />}
                </div>

                <div className='header_box'>
                    <Language />

                    {(mode == consts.headerMode.NORMAL || mode == consts.headerMode.BACK) && token ? (
                        <>
                            <Credits />
                            <Profile />
                        </>
                    ) : (
                        <>
                            <button className={`login ${consts.animationFadeIn}`} onClick={() => {
                                openSignPop()
                            }}>
                                <LangText id={'login/join'} />
                            </button>
                        </>
                    )}
                </div>
            </motion.nav>

            <LeftNav />
        </>
    )
}